<template>
    <div class="nominas">    
        
        <div class="row p-1">
            <!-- Empleados -->        
            <div class=col-sm-7>
                <b-table striped hover bordered small
                    id="emp"
                    sticky-header="400px" head-variant="light"
                    :items="EMP" :fields="fieldsE"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-compare="sortCompare"
                    selectable select-mode="single" @row-selected="selecciona"
                    class="bg-white" responsive>

                </b-table>
            </div>
            <!-- Nominas -->
            <div class=col-sm-5>
                 <b-table striped hover bordered small
                    id="nom"
                    sticky-header="400px" head-variant="light"
                    :items="NOM" :fields="fieldsN"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-compare="sortCompare"
                    class="bg-white" responsive>

                    <!-- <template #cell(icono)="{ item }">
                        <p class="h4 mb-1">
                            <b-icon
                                v-b-tooltip.right.hover :title="iconoStd(item.std).name" 
                                :icon="iconoStd(item.std).icon"
                                :variant="iconoStd(item.std).color">>
                            </b-icon>
                        </p>                
                    </template>  -->

                </b-table>
            </div>
        </div>
        
        <!-- <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="tablaReservas"
        ></b-pagination> -->
    </div>
</template>

<script>

    import { mapState, mapMutations, mapActions } from 'vuex';

    export default {
        name: 'nominas',
        props: {
            //padre: { type:String, default: '' },                                     
            EMP: { type:Array, default: ()=> [] },           
             
        },
        components: {            
        },
        data() {
            return {

                NOM: [],

                fieldsE: [
                    //{ key: 'action', label:'' },    
                    { key: 'icono', label:'' },                
                    { key: 'name', label: 'Empleado', sortable: true },                
                    { key: 'coste', label: 'Coste', sortable: true },                                       
                    
                ],     
                fieldsN: [
                    //{ key: 'action', label:'' },    
                    { key: 'icono', label:'' },                
                    { key: 'Fecha', label: 'Fecha', sortable: true },                
                    { key: 'T', label: 'T', sortable: true },
                    { key: 'Importe', label: 'Importe', sortable: true },                                                           

                ],              

                itemsStd:[
                    {value:'0', text:'(Estado)'},
                    {value:'1', text:'ACTIVO'},
                    {value:'2', text:'FINALIZADO'},
                    {value:'3', text:'ANULADO'},
                ],

                perPage: 0,
                currentPage: 1,
                
            }
        },
        computed: {
            ...mapState(['auth']),         
            
            /* NOM() {
                return Object.values(this.EMP[0].N);
            } */
            
            // cbStd() {
            //     return this.itemsStd;
            // }

        },
        mounted() {            

            //this.leemos();
            this.selecciona(this.EMP[0]);

        },
        methods: {
            ...mapMutations(['loading','alerta','modal']),
            ...mapActions(['exec']),

            // ordena numéricamente las columnas de importes (vienen como texto, en formato
            // español "1.234,56" o con punto decimal "1234.56" según el origen del dato)
            sortCompare(a, b, key) {
                if (key!=='coste' && key!=='Importe') return null;

                return this.$util.SN(a[key]) - this.$util.SN(b[key]);
            },

            selecciona(item) {
                console.log("*selecciona",item);
                if (item==undefined) return;        
                
                this.NOM=Object.values(item[0].N);
            },

            //iconoStd(std) {                
                //return this.estados[std];
            //}
        }
    }
</script>